
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Description extends Vue {
  name: string = "description";
}
